{
    "title": "Skabeloner",
    "subtitle": "Vælg en dagbogsopsætning"
}
